import { render, staticRenderFns } from "./CustomRadioGroup.vue?vue&type=template&id=301be148&"
import script from "./CustomRadioGroup.vue?vue&type=script&lang=js&"
export * from "./CustomRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports